"use client";

import { createSVGIcon } from "@faire/slate/lib/iconUtils";
import React from "react";

/**
 * @figma designed by Gabe Kelley (see [Figma](https://figma.com/file/qcB5qVN7uKBBYHN49ihDE7?node-id=8943%3A1113))
 * @trackcomponent
 * @lastsynced 2025-07-07T16:19:10.601Z
 */
export const Croatia = createSVGIcon(
  <>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M1 2V14H17V2H1Z"
      fill="#F7FCFF"
    />
    <mask
      id="mask0_8943_1113"
      style={{ maskType: "luminance" }}
      maskUnits="userSpaceOnUse"
      x="1"
      y="2"
      width="16"
      height="12"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M1 2V14H17V2H1Z"
        fill="white"
      />
    </mask>
    <g mask="url(#mask0_8943_1113)">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M1 2V6H17V2H1Z"
        fill="#E31D1C"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M1 10V14H17V10H1Z"
        fill="#3D58DB"
      />
      <path
        d="M6.03857 5.19901H11.7386V7.19901H6.03857V5.19901Z"
        fill="#E31D1C"
      />
      <path
        d="M6.32617 6.48H11.3907C11.3992 6.8645 11.4017 7.535 11.4017 8.181C11.4016 8.67166 11.4004 9.16233 11.3982 9.653L11.3977 9.7515V9.766L11.3972 9.7675C11.3788 9.86741 11.3542 9.9661 11.3237 10.063C11.2439 10.3174 11.1274 10.5588 10.9777 10.7795C10.6307 11.2865 10.0002 11.8075 8.82517 11.8075C7.65167 11.8075 7.05167 11.2875 6.73217 10.785C6.53983 10.4782 6.41411 10.1345 6.36317 9.776L6.36217 9.7675V9.745L6.36067 9.647L6.35667 9.2925C6.3459 8.355 6.3354 7.4175 6.32617 6.48Z"
        fill="#F7FCFF"
        stroke="#E31D1C"
        strokeWidth="0.5625"
      />
      <mask
        id="mask1_8943_1113"
        style={{ maskType: "luminance" }}
        maskUnits="userSpaceOnUse"
        x="6"
        y="6"
        width="6"
        height="7"
      >
        <path
          d="M6.32617 6.48H11.3907C11.3992 6.8645 11.4017 7.535 11.4017 8.181C11.4016 8.67166 11.4004 9.16233 11.3982 9.653L11.3977 9.7515V9.766L11.3972 9.7675C11.3788 9.86741 11.3542 9.9661 11.3237 10.063C11.2439 10.3174 11.1274 10.5588 10.9777 10.7795C10.6307 11.2865 10.0002 11.8075 8.82517 11.8075C7.65167 11.8075 7.05167 11.2875 6.73217 10.785C6.53983 10.4782 6.41411 10.1345 6.36317 9.776L6.36217 9.7675V9.745L6.36067 9.647L6.35667 9.2925C6.3459 8.355 6.3354 7.4175 6.32617 6.48Z"
          fill="white"
          stroke="white"
          strokeWidth="0.5625"
        />
      </mask>
      <g mask="url(#mask1_8943_1113)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M6.24902 6.51999H7.30402V7.59099H6.24902V6.51999ZM8.35902 7.59099H7.30402V8.66199H6.24902V9.73299H7.30402V10.804H6.24902V11.875H7.30402V10.804H8.35902V11.875H9.41352V10.804H10.468V11.875H11.523V10.804H10.468V9.73299H11.523V8.66199H10.468V7.59099H11.523V6.51999H10.468V7.59099H9.41302V6.51999H8.35852V7.59099H8.35902ZM8.35902 8.66199V7.59099H9.41302L9.41352 8.66199H8.35852H8.35902ZM8.35902 9.73299V8.66199H7.30402V9.73299H8.35902ZM9.41352 9.73299V10.804H8.35852V9.73299H9.41352ZM9.41352 9.73299V8.66199H10.468V9.73299H9.41352Z"
          fill="#F50100"
        />
      </g>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M6.22671 6.081C6.22671 6.081 6.55321 5.907 6.83171 5.817C7.10971 5.727 7.32921 5.6785 7.32921 5.6785L6.91521 4.1525L6.08621 3.8425L5.61621 4.6165L6.22671 6.0815V6.081Z"
        fill="#56C6F5"
        stroke="white"
        strokeWidth="0.25"
      />
      <path
        d="M6.09033 5.245L6.18533 5.1995C6.28383 5.4095 6.41383 5.4745 6.59133 5.4085C6.77333 5.341 6.84733 5.2125 6.82133 5.0095L6.92583 4.9955C6.95783 5.248 6.85633 5.424 6.62783 5.509C6.39583 5.5955 6.21083 5.503 6.09033 5.2455V5.245Z"
        fill="white"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M6.31659 4.771L6.22509 4.826C6.2206 4.82859 6.21547 4.82983 6.2103 4.82958C6.20513 4.82933 6.20015 4.82761 6.19593 4.8246C6.19172 4.8216 6.18845 4.81745 6.18653 4.81264C6.18461 4.80784 6.18411 4.80258 6.18509 4.7975L6.20509 4.693L6.11209 4.642C6.10741 4.63954 6.10355 4.63576 6.101 4.63112C6.09845 4.62649 6.09732 4.6212 6.09774 4.61593C6.09817 4.61066 6.10014 4.60563 6.1034 4.60146C6.10666 4.5973 6.11107 4.59418 6.11609 4.5925L6.21709 4.558L6.21509 4.4515C6.21491 4.44622 6.2163 4.44099 6.21906 4.43649C6.22183 4.43198 6.22586 4.42838 6.23065 4.42615C6.23545 4.42391 6.24079 4.42313 6.24603 4.42391C6.25126 4.42468 6.25615 4.42697 6.26009 4.4305L6.34009 4.5005L6.43109 4.4455C6.45109 4.4335 6.47609 4.451 6.47159 4.474L6.45109 4.579L6.54459 4.63C6.54925 4.63255 6.55305 4.63641 6.55553 4.64111C6.558 4.64581 6.55904 4.65113 6.55851 4.65641C6.55797 4.66169 6.55589 4.6667 6.55253 4.67081C6.54916 4.67492 6.54466 4.67794 6.53959 4.6795L6.43959 4.7135L6.44159 4.82C6.44176 4.82529 6.44038 4.83051 6.43761 4.83502C6.43484 4.83953 6.43081 4.84312 6.42602 4.84536C6.42123 4.8476 6.41588 4.84837 6.41065 4.8476C6.40542 4.84683 6.40053 4.84453 6.39659 4.841L6.31659 4.771Z"
        fill="#FECA00"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8.27017 5.538C8.27017 5.538 8.54867 5.513 8.84117 5.519C9.13367 5.524 9.38117 5.5265 9.38117 5.5265L9.52367 4.0215L8.89717 3.4565L8.20117 4.035L8.27067 5.538H8.27017Z"
        fill="#56C6F5"
        stroke="white"
        strokeWidth="0.25"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8.8749 5.29249C9.1164 5.29249 9.1394 5.03249 9.1394 4.85449C9.0779 4.75599 9.0899 4.68599 8.8924 4.68599C8.6949 4.68599 8.6724 4.74549 8.6144 4.85449C8.6144 5.03199 8.6339 5.29249 8.8749 5.29249ZM9.1464 4.55649C9.3874 4.55649 9.4109 4.29599 9.4109 4.11849C9.3489 4.01999 9.3614 3.94949 9.1639 3.94949C8.9659 3.94949 8.9439 4.00949 8.8859 4.11849C8.8859 4.29599 8.9054 4.55649 9.1464 4.55649ZM8.6189 4.55649C8.8604 4.55649 8.8834 4.29599 8.8834 4.11849C8.8219 4.01999 8.8339 3.94949 8.6364 3.94949C8.4389 3.94949 8.4164 4.00949 8.3584 4.11849C8.3584 4.29599 8.3779 4.55649 8.6189 4.55649Z"
        fill="#FECA00"
      />
      <path
        d="M7.22242 5.8025L7.18642 5.68L6.75292 4.2085L6.73242 4.1385L6.78242 4.086L7.40242 3.444L7.47692 3.367L7.56442 3.429L8.24592 3.913L8.29292 3.9465L8.29792 4.004L8.42392 5.4665L8.43542 5.5965L8.30492 5.602H8.30192L8.29292 5.6025L8.25892 5.604L8.14242 5.611C8.04147 5.61717 7.94075 5.62668 7.84042 5.6395C7.73413 5.65723 7.62895 5.6811 7.52542 5.711C7.48195 5.72285 7.43861 5.73518 7.39542 5.748L7.35742 5.76L7.34742 5.763L7.34442 5.764H7.34392L7.22242 5.8025Z"
        fill="#2E42A5"
        stroke="white"
        strokeWidth="0.25"
      />
      <mask
        id="mask2_8943_1113"
        style={{ maskType: "luminance" }}
        maskUnits="userSpaceOnUse"
        x="6"
        y="3"
        width="3"
        height="3"
      >
        <path
          d="M7.22242 5.8025L7.18642 5.68L6.75292 4.2085L6.73242 4.1385L6.78242 4.086L7.40242 3.444L7.47692 3.367L7.56442 3.429L8.24592 3.913L8.29292 3.9465L8.29792 4.004L8.42392 5.4665L8.43542 5.5965L8.30492 5.602H8.30192L8.29292 5.6025L8.25892 5.604L8.14242 5.611C8.04147 5.61717 7.94075 5.62668 7.84042 5.6395C7.73413 5.65723 7.62895 5.6811 7.52542 5.711C7.48195 5.72285 7.43861 5.73518 7.39542 5.748L7.35742 5.76L7.34742 5.763L7.34442 5.764H7.34392L7.22242 5.8025Z"
          fill="white"
          stroke="white"
          strokeWidth="0.25"
        />
      </mask>
      <g mask="url(#mask2_8943_1113)">
        <path
          d="M7.21834 5.319L7.09284 5.024C7.36184 4.906 7.81634 4.834 8.29434 4.8055L8.31284 5.1265C7.86784 5.1525 7.44784 5.2185 7.21784 5.319H7.21834ZM7.00684 4.605L6.88184 4.31C7.15034 4.1925 7.72884 4.097 8.20684 4.069L8.22534 4.3895C7.78034 4.416 7.23634 4.5045 7.00684 4.605Z"
          fill="#C51918"
        />
      </g>
      <path
        d="M10.4846 5.80351L10.5186 5.67751L10.9161 4.20301L10.9341 4.13701L10.8881 4.08651L10.3041 3.44651L10.2291 3.36501L10.1391 3.42901L9.45805 3.91301L9.41055 3.94651L9.40555 4.00401L9.27955 5.46651L9.26855 5.59651L9.39905 5.60201H9.40205L9.41105 5.60251L9.44505 5.60401L9.56105 5.61101C9.65505 5.61751 9.77105 5.62651 9.86355 5.63951C9.95205 5.65201 10.0746 5.68201 10.1786 5.71101C10.2301 5.72501 10.2756 5.73851 10.3086 5.74801L10.3466 5.76001L10.3566 5.76301L10.3591 5.76401H10.3601L10.4846 5.80351Z"
        fill="#2E42A5"
        stroke="white"
        strokeWidth="0.25"
      />
      <mask
        id="mask3_8943_1113"
        style={{ maskType: "luminance" }}
        maskUnits="userSpaceOnUse"
        x="9"
        y="3"
        width="3"
        height="3"
      >
        <path
          d="M10.4846 5.80351L10.5186 5.67751L10.9161 4.20301L10.9341 4.13701L10.8881 4.08651L10.3041 3.44651L10.2291 3.36501L10.1391 3.42901L9.45805 3.91301L9.41055 3.94651L9.40555 4.00401L9.27955 5.46651L9.26855 5.59651L9.39905 5.60201H9.40205L9.41105 5.60251L9.44505 5.60401L9.56105 5.61101C9.65505 5.61751 9.77105 5.62651 9.86355 5.63951C9.95205 5.65201 10.0746 5.68201 10.1786 5.71101C10.2301 5.72501 10.2756 5.73851 10.3086 5.74801L10.3466 5.76001L10.3566 5.76301L10.3591 5.76401H10.3601L10.4846 5.80351Z"
          fill="white"
          stroke="white"
          strokeWidth="0.25"
        />
      </mask>
      <g mask="url(#mask3_8943_1113)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M10.1992 5.2335C10.1992 5.2335 10.3462 5.1515 10.3672 5.0135C10.3882 4.8755 10.6157 4.7055 10.5022 4.726C10.3882 4.746 10.4532 4.762 10.2887 4.726C10.1242 4.69 9.91118 4.666 9.91118 4.565C9.91118 4.4635 10.0172 4.3835 9.93068 4.3835C9.84368 4.3835 9.65918 4.2875 9.69618 4.361C9.73318 4.434 9.61118 4.351 9.67218 4.503C9.73318 4.655 9.65918 4.808 9.69618 4.8485C9.73318 4.8885 9.67218 5.0865 9.67218 5.0865C9.67218 5.0865 9.69468 5.16 9.73418 5.05C9.77318 4.94 9.85918 4.863 9.81618 4.9565C9.77318 5.05 9.71818 5.2725 9.76718 5.2335C9.81779 5.18376 9.85198 5.11973 9.86518 5.05C9.86518 5.0135 9.98868 4.8705 9.98868 4.9785C9.98868 5.0865 9.87218 5.1715 9.93068 5.1715C9.98868 5.1715 10.0207 5.1945 10.0577 5.0865C10.0942 4.9785 10.1827 4.907 10.2192 4.9785C10.2557 5.05 10.2477 5.046 10.1992 5.1395C10.1502 5.2335 10.1992 5.2335 10.1992 5.2335Z"
          fill="#FECA00"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M9.85352 4.4335L9.79852 4.3415C9.89702 4.2815 9.98752 4.265 10.0665 4.299C10.1025 4.314 10.1295 4.3315 10.2005 4.3815L10.2095 4.388C10.283 4.4395 10.322 4.4605 10.346 4.4605V4.5675C10.291 4.5675 10.2435 4.542 10.1495 4.476L10.1405 4.4695C10.1048 4.4416 10.0662 4.41747 10.0255 4.3975C9.98202 4.379 9.92552 4.389 9.85352 4.4335ZM9.68052 5.1315C9.71152 5.1315 9.73702 5.1065 9.73702 5.0765C9.73702 5.0691 9.73556 5.06178 9.73271 5.05495C9.72987 5.04813 9.7257 5.04193 9.72045 5.03672C9.71519 5.03152 9.70896 5.0274 9.70211 5.02462C9.69526 5.02183 9.68792 5.02043 9.68052 5.0205C9.67317 5.02043 9.66587 5.02182 9.65905 5.02457C9.65224 5.02732 9.64603 5.03139 9.64078 5.03655C9.63553 5.0417 9.63135 5.04784 9.62848 5.05461C9.6256 5.06138 9.62409 5.06865 9.62402 5.076C9.62402 5.107 9.64902 5.132 9.68052 5.132V5.1315ZM9.84202 5.1835C9.84202 5.2135 9.81702 5.2385 9.78602 5.2385C9.77126 5.23863 9.75703 5.23293 9.74645 5.22263C9.73587 5.21233 9.72979 5.19827 9.72952 5.1835C9.72952 5.1525 9.75452 5.1275 9.78602 5.1275C9.81702 5.1275 9.84202 5.1525 9.84202 5.1835ZM9.97552 5.2345C10.0065 5.2345 10.0315 5.2095 10.0315 5.1795C10.0315 5.16465 10.0256 5.1504 10.0151 5.1399C10.0046 5.1294 9.99038 5.1235 9.97552 5.1235C9.96817 5.12343 9.96087 5.12482 9.95405 5.12757C9.94724 5.13032 9.94103 5.13439 9.93578 5.13955C9.93053 5.1447 9.92635 5.15084 9.92348 5.15761C9.9206 5.16438 9.91909 5.17165 9.91902 5.179C9.91902 5.21 9.94402 5.2345 9.97552 5.2345ZM10.208 5.268C10.208 5.299 10.183 5.3235 10.1515 5.3235C10.1368 5.3235 10.1227 5.31774 10.1123 5.30745C10.1018 5.29717 10.0958 5.28318 10.0955 5.2685C10.0955 5.2375 10.1205 5.2125 10.1515 5.2125C10.183 5.2125 10.208 5.2375 10.208 5.268Z"
          fill="#C51918"
        />
      </g>
      <path
        d="M11.6767 6.093L11.6227 6.2175L11.5027 6.1535L11.4997 6.1515L11.4897 6.1465L11.4497 6.126C11.4037 6.10265 11.3574 6.07999 11.3107 6.058C11.1836 5.9968 11.0528 5.94337 10.9192 5.898C10.7706 5.85025 10.6204 5.80789 10.4687 5.771L10.4412 5.7645L10.4342 5.7625H10.4322L10.3027 5.7335L10.3392 5.606L10.7622 4.118L10.7792 4.0575L10.8387 4.035L11.6677 3.725L11.7647 3.689L11.8182 3.7775L12.2882 4.5515L12.3212 4.607L12.2957 4.6665L11.6767 6.093Z"
        fill="#56C6F5"
        stroke="white"
        strokeWidth="0.25"
      />
      <mask
        id="mask4_8943_1113"
        style={{ maskType: "luminance" }}
        maskUnits="userSpaceOnUse"
        x="10"
        y="3"
        width="3"
        height="4"
      >
        <path
          d="M11.6767 6.093L11.6227 6.2175L11.5027 6.1535L11.4997 6.1515L11.4897 6.1465L11.4497 6.126C11.4037 6.10265 11.3574 6.07999 11.3107 6.058C11.1836 5.9968 11.0528 5.94337 10.9192 5.898C10.7706 5.85025 10.6204 5.80789 10.4687 5.771L10.4412 5.7645L10.4342 5.7625H10.4322L10.3027 5.7335L10.3392 5.606L10.7622 4.118L10.7792 4.0575L10.8387 4.035L11.6677 3.725L11.7647 3.689L11.8182 3.7775L12.2882 4.5515L12.3212 4.607L12.2957 4.6665L11.6767 6.093Z"
          fill="white"
          stroke="white"
          strokeWidth="0.25"
        />
      </mask>
      <g mask="url(#mask4_8943_1113)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M11.564 4.545L11.493 4.624C11.4896 4.62806 11.485 4.63102 11.4799 4.6325C11.4748 4.63397 11.4694 4.63391 11.4643 4.63231C11.4592 4.6307 11.4547 4.62763 11.4514 4.62349C11.4481 4.61934 11.446 4.6143 11.4455 4.609L11.435 4.5025L11.3305 4.481C11.3254 4.47992 11.3207 4.47736 11.317 4.47363C11.3132 4.46991 11.3107 4.46518 11.3096 4.46003C11.3086 4.45488 11.309 4.44953 11.311 4.44464C11.3129 4.43975 11.3162 4.43553 11.3205 4.4325L11.407 4.37L11.3735 4.269C11.3717 4.26397 11.3715 4.25851 11.3728 4.25333C11.3741 4.24814 11.3769 4.24346 11.3808 4.23987C11.3848 4.23629 11.3897 4.23396 11.395 4.23318C11.4003 4.2324 11.4057 4.23321 11.4105 4.2355L11.5075 4.2795L11.5785 4.1995C11.5821 4.19557 11.5867 4.19276 11.5918 4.19143C11.5969 4.19009 11.6023 4.19029 11.6073 4.19199C11.6123 4.1937 11.6167 4.19683 11.62 4.20101C11.6232 4.20519 11.6251 4.21023 11.6255 4.2155L11.6365 4.3215L11.7405 4.343C11.7635 4.348 11.7705 4.378 11.7505 4.3915L11.6645 4.454L11.698 4.555C11.6997 4.56 11.6999 4.56538 11.6985 4.57048C11.6971 4.57557 11.6943 4.58016 11.6904 4.58366C11.6865 4.58717 11.6816 4.58945 11.6764 4.59022C11.6711 4.59099 11.6658 4.59022 11.661 4.588L11.564 4.5445V4.545Z"
          fill="#FECA00"
        />
        <path
          d="M10.4976 5.24349L10.6036 4.82899C11.0741 4.95349 11.5646 5.11249 11.9241 5.26649L11.7606 5.66149C11.4206 5.51599 10.9491 5.36299 10.4976 5.24349Z"
          fill="#E31D1C"
        />
        <path
          d="M10.6418 4.861L10.6668 4.757C11.1178 4.8685 11.5968 5.047 11.9453 5.2135L11.9003 5.3105C11.496 5.12104 11.0746 4.97037 10.6418 4.8605V4.861ZM10.5083 5.288L10.5333 5.184C10.9843 5.296 11.4013 5.448 11.7493 5.614L11.7043 5.711C11.3207 5.53066 10.92 5.38896 10.5083 5.288Z"
          fill="white"
        />
        <path
          d="M10.7114 5.08751L10.8079 5.04401C10.8489 5.13901 10.8989 5.16001 10.9829 5.11901C11.1809 5.02301 11.6729 5.15751 11.6729 5.33901C11.6729 5.41001 11.6319 5.45301 11.5694 5.45051C11.5239 5.44528 11.48 5.43064 11.4404 5.40751C11.4331 5.40387 11.4257 5.40021 11.4184 5.39651C11.392 5.38148 11.3646 5.36828 11.3364 5.35701L11.3714 5.25501C11.3939 5.26301 11.3974 5.26501 11.4654 5.29951L11.4864 5.30951C11.5133 5.32526 11.5428 5.33625 11.5734 5.34201C11.5749 5.34201 11.5674 5.34951 11.5674 5.33901C11.5674 5.25901 11.1674 5.14951 11.0279 5.21751C10.8889 5.28501 10.7754 5.23751 10.7114 5.08751Z"
          fill="#272727"
        />
      </g>
    </g>
    <rect x="1" y="2" width="16" height="12" stroke="#757575" />
  </>,
  "Croatia",
  { fill: "none", viewBox: "0 0 18 16" } // This icon is decorative, keep titleAccess empty so it doesn't clutter the screenreader experience
);
